import ds from './DataSourceService'

const baseUrl = '/media-manager'

const getMediaById = ids => {
  return ds.apiClientThinkHome.get(baseUrl, { params: { mediaId: ids } })
}

const getMedia = (projectId, params) => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + projectId, {
    params
  })
}

const createMedia = (projectId, params) => {
  return ds.apiClientThinkHome.post(baseUrl + '/upload/' + projectId, params)
}

const deleteMedia = ids => {
  return ds.apiClientThinkHome.delete(baseUrl, { params: { mediaId: ids } })
}

const linkMedia = (projectId, arr) => {
  return ds.apiClientThinkHome.post(
    baseUrl + '/' + projectId + '/media-content',
    { data: arr }
  )
}

const getMediaPois = (projectId, mediaId) => {
  return ds.apiClientThinkHome.get(
    baseUrl + '/' + projectId + '/media-content/pois',
    { params: { mediaId: mediaId } }
  )
}

const deleteMediaRecord = (projectId, params) => {
  return ds.apiClientThinkHome.delete(
    baseUrl + '/' + projectId + '/media-content/pois',
    { data: params }
  )
}

const deletePoiContent = (projectId, params) => {
  return ds.apiClientThinkHome.delete(
    baseUrl + '/' + projectId + '/media-content/poi',
    { data: params }
  )
}

const getTreeView = (projectId, mediaId) => {
  return ds.apiClientThinkHome.get(baseUrl + '/alldata', {
    params: { mediaId: mediaId, projectId: projectId }
  })
}

const setMediaLinks = params => {
  return ds.apiClientThinkHome.post(baseUrl + '/alldata', { data: params })
}

const getThumbnail = imgFileName => {
  return ds.apiClientThinkHome.get('/uploads/thumbnails/' + imgFileName)
}

// const getMediaTypes = type => {
//   let sufix = ``
//   type ? (sufix = `?context=${type}`) : (sufix = '')
//   return ds.apiClientThinkHome.get(baseUrl + '/types' + sufix)
// }

const updateMedia = (projectId, params) => {
  return ds.apiClientThinkHome.patch(
    baseUrl + '/' + projectId + '/media-content/pois',
    params
  )
}

const upload = files => {
  return ds.apiClientThinkHome.post(baseUrl + '/upload', files, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

const getMediaFile = fileUrl => {
  return ds
    .apiClientThinkHome({
      method: 'get',
      url: fileUrl,
      responseType: 'arraybuffer'
    })
    .catch(e => {})
}

export default {
  getMediaById,
  getMedia,
  createMedia,
  deleteMedia,
  getThumbnail,
  // getMediaTypes,
  linkMedia,
  getMediaPois,
  deleteMediaRecord,
  deletePoiContent,
  getTreeView,
  setMediaLinks,
  updateMedia,
  upload,
  getMediaFile
}
